import Typography from "antd/es/typography";
import { Card, List, Space, Tag } from "antd";
import { SettingOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const SerieCard = (props) => {
  const navigate = useNavigate();
  const { serie, type, onClickAdd } = props;

  const description = () => {
    return (
      <Space direction="vertical" wrap>
        <Tag
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            navigator.clipboard.writeText(serie.id);
          }}
        >
          ID {serie.id}
        </Tag>
        <Text>{serie.CollectionName}</Text>
        <Space size={"small"} direction="vertical">
          <Text type="secondary">Auteur: {serie.author}</Text>
          <Text type="secondary">Illustrateur: {serie.illustrator}</Text>
        </Space>
        <Text type={serie.statut === "unavailable" ? "danger" : "success"}>
          {serie.statut}
        </Text>
      </Space>
    );
  };

  const getActions = () => {
    switch (type) {
      case "add":
        return [
          <PlusOutlined
            onClick={() => {
              if (onClickAdd) onClickAdd(serie);
            }}
            key="add"
          />,
        ];
      default:
        return [
          <EditOutlined
            onClick={() => {
              navigate(`/serie/${serie.id}/details/`, {
                state: { serie },
              });
            }}
            key="edit"
          />,
          <SettingOutlined
            onClick={() => {
              navigate(`/serie/${serie.id}`, {
                state: { serie, collectionName: serie.CollectionName },
              });
            }}
            key="setting"
          />,
        ];
    }
  };

  return (
    <List.Item>
      <Card
        cover={
          <img
            alt="example"
            src={
              serie.imgHeader
                ? `https://newbrand.s3.eu-west-3.amazonaws.com/series/${serie.uid}/headers/${serie.imgHeader}`
                : null
            }
          />
        }
        actions={getActions()}
      >
        <Meta title={serie.name} description={description(serie)} />
      </Card>
    </List.Item>
  );
};

export default SerieCard;
